import React from "react";
import { Link } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet-async";

//Import Context
import {AppContext} from '../../App'

//Import Css
import './quienesSomos.css'

//Import Component
import MenuScrollBarComponent from "../menuScrollBarComponent/menuScrollBarComponent";
import {FooterComponent} from '../footerComponent/footerComponent'

//Import Assets
import bannerQSomosParalax from '../../assets/quienesSomosAssets/BannerQsomosParalax.jpg'
import logoMonitronix from '../../assets/homeAssets/logo-monitronix.svg'
import photoCalidad from '../../assets/quienesSomosAssets/photoCalidad.jpg'
import photoCollage1 from '../../assets/quienesSomosAssets/photo-collage-1.jpg'
import photoCollage2 from '../../assets/quienesSomosAssets/photo-collage-2.jpg'
import photoCollage3 from '../../assets/quienesSomosAssets/photo-collage-3.jpg'
import bannerRedesSeo from '../../assets/SeoAssets/BannerRedes.jpg'


export default function QuienesSomos(){

    const {

    // Props Menu Bar Scroll Page
      linkUrl,
      nameClass,
      namePage

    } = useContext(AppContext); 

    // Background Portada Q somos 
    const isMobilePortadaQSomos = window.innerWidth <= 620;
    const styleBkBannerQSomosParalax = {
        backgroundImage: `url(${bannerQSomosParalax})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center -220px',
        backgroundAttachment: "fixed",
        width: '100%',
        height: isMobilePortadaQSomos? '60vh' : '380px',
    }

    return(
<>
   <Helmet>
        <title>Quiénes Somos</title>
        <meta
          name="description"
          content="Somos Expertos en Seguridad Electrónica."
        />
        <meta
          name="keywords"
          content="Empresa, Seguridad, Electrónica, Servicio, Técnico, Mantenimiento, Reparación, Assitencia, Domicilio, Monitoreo, Vigilancia, Alarmas, Cámaras, CCTV"
        />
        <meta name="author" content="Monitronix" />
        {/* Metadatos para redes sociales */}
        <meta property="og:title" content="Quiénes Somos - Monitronix" />
        <meta
          property="og:description"
          content="Soluciones integrales en seguridad electrónica"
        />
        <meta property="og:image" content={bannerRedesSeo} />
        <meta property="og:type" content="website" />
    </Helmet>


    <div className="container-q-somos-component">

        {/* // Sección menú scroll bar */}
        <div className="container-menu-component">

          <MenuScrollBarComponent 
          
                linkUrl1={linkUrl[0]}
                linkUrl2={linkUrl[2]}
                linkUrl3={linkUrl[3]}
                linkUrl4={linkUrl[4]}
  

                nameClass1={nameClass[0]}
                nameClass2={nameClass[2]}
                nameClass3={nameClass[3]}
                nameClass4={nameClass[4]}
              

                namePage1={namePage[0]}
                namePage2={namePage[2]}
                namePage3={namePage[3]}
                namePage4={namePage[4]}
          
          />

        </div>

        {/* // SECCIÓN BANNER Q-SOMOS */}
        <div className="banner-top-q-somos" style={styleBkBannerQSomosParalax}>

          <div className="box-text-q-somos">
            <h2 className="title-q-somos">QUIENES SOMOS</h2>
            <p className="text-slogan-q-somos">¡EXPERTOS EN SEGURIDAD ELECTRONICA<br></br>AVANZADA!</p>
          </div>

          <div className="box-logo-banner-monitronix-q-somos">
            <img className="logo-banner-monitronix-q-somos" src={logoMonitronix}/>
          </div>

        </div>


        {/* // SECCIÓN EMPRESA */}
        <div className="container-info-empresa">

            <h2 className="title-empresa-q-somos">MONITRONIX SAS</h2>
            <p className="text-info-empresa-q-somos">Somos una empresa de Seguridad Electrónica Privada legalmente constituida en el 
              mercado al servicio de la sociedad, nuestro equipo de trabajo está conformado por 
              trabajadores comprometidos, eficientes y altamente calificados y capacitados, 
              estamos dedicados a brindar servicio de Instalación, Mantenimiento y Monitoreo a 
              pequeñas, medianas y grandes empresas. </p>

        </div>

        {/* // SECCIÓN CALIDAD */}
        <div className="container-calidad-q-somos">

            <div className="box-text-calidad">
                <h2 className="title-calidad">COMPROMISO<br></br>CON LA CALIDAD</h2>
                <p className="text-info-calidad">
                  Somos una compañía orientada a satisfacer las más exigentes 
                  necesidades de seguridad electrónica para brindar soluciones 
                  integrales y eficientes  que resguarden a su familia, bienes 
                  y negocios con eficiencia, calidad y garantía.</p>
            </div>

            <div className="box-photo-calidad" >
                <img className="photo-calidad" src={photoCalidad}/>
            </div>
        </div>


          {/* // SECCIÓN BANNER OBJETIVOS */}
          <div className="container-mision-vision-objetivos">

              {/* BLOQUE A */}
              <div className="bloque-mv bloque-A">

                <h2 className="title-bloque title-mision">MISIÓN</h2>
                <p className="text-info-mision">
                    Brindar a nuestros clientes la más alta calidad en 
                    servicios de Seguridad Electrónica y Equipos 
                    Especializados además de un sistema de Seguridad 
                    Integral con soluciones globales a los requerimientos 
                    de seguridad, con personal eficiente y óptimo con 
                    constante innovación tecnológica, respaldando la 
                    tranquilidad, seguridad y confianza de nuestros clientes, 
                    convirtiéndonos en el aliado perfecto.
                </p>

              </div>


              {/* --- Linea Divisioria --- */}
              <div className="bloque-mv bloque-line"></div>



                {/* BLOQUE B */}
              <div className="bloque-mv bloque-b">

              <h2 className="title-bloque title-mision">VISIÓN</h2>
                <p className="text-info-mision">
                    Posesionarnos como empresa líder del mercado en servicios 
                    de Seguridad Electrónica, con crecimiento continuo a 
                    nivel nacional garantizando la calidad de nuestro trabajo
                    marcando la diferencia por nuestra experiencia dando 
                    respuesta inmediata a las necesidades globales.
                </p>

              </div>

              {/* --- Linea Divisioria --- */}
              <div className="bloque-mv bloque-line"></div>


              {/* BLOQUE C */}
              <div className="bloque-mv bloque-c">


              <h2 className="title-bloque title-objetivos">OBJETIVOS</h2>
                <p className="text-info-mision">
                      Preveer a la sociedad en general un Sistema de Seguridad Integral, 
                      determinando puntualmente las vulnerabilidades y acciones que puedan 
                      minimizar las situaciones de riesgo e inseguridad.
                </p>

              </div>

          </div>


               {/* // SECCIÓN VALORES CORPORATIVOS */}
              <div className="container-valores-corporativos">

                  <div className="box-title-v-corporativos">
                    <h2 className="title-v-corporativos">VALORES CORPORATIVOS</h2> 
                  </div>

                  <div className="container-collage-corporativo">
                      <img className="photo-collage-corp photo1" alt="Valores Corporativos" src={photoCollage1} />
                      <img className="photo-collage-corp photo1" alt="Valores Corporativos" src={photoCollage2} />
                      <img className="photo-collage-corp photo1" alt="Valores Corporativos" src={photoCollage3} />
                  </div>


                  <div className="box-bloque-valores bloque-valores-A">

                      <div className="bloque-contenido-valores bloque-cv-honestidad">

                          <h2 className="title-bloque-valores title-honestidad">HONESTIDAD</h2>
                          <p className="text-info-valores">
                              Transparencia en nuestros procesos y proyectos.
                          </p>

                      </div>
                        
                      <div className="bloque-contenido-valores bloque-cv-lealtad">

                          <h2 className="title-bloque-valores title-lealtad">LEALTAD</h2>
                          <p className="text-info-valores">
                            Confidencialidad total e íntegra con nuestros clientes. 
                          </p>

                      </div>

                      <div className="bloque-contenido-valores bloque-cv-respeto">

                        <h2 className="title-bloque-valores title-respeto">RESPETO</h2>
                          <p className="text-info-valores">
                                Respero es valorar el trabajo de nuestros clientes y colaboradores
                          </p>

                      </div>

                  </div>

                  <div className="box-bloque-valores bloque-valores-B">

                      <div className="bloque-contenido-valores bloque-cv-cumplimiento">

                       <h2 className="title-bloque-valores title-cumplimiento">CUMPLIMIENTO</h2>
                        <p className="text-info-valores">
                            Nuestro compromiso a brindar un servicio a tiempo y eficiente con la mejor asistencia.
                        </p>

                      </div>


                      <div className="bloque-contenido-valores bloque-cv-integridad">

                        <h2 className="title-bloque-valores title-integridad">INTEGRIDAD</h2>
                        <p className="text-info-valores">
                            Transparencia, disciplina, lealtad y responsabilidad son los pilares de nuestro servicio.
                        </p>

                      </div>


                      <div className="bloque-contenido-valores bloque-cv-responsabilidad">

           
                        <h2 className="title-bloque-valores title-responsabilidad">RESPOSABILIDAD</h2>
                          <p className="text-info-valores">
                            Compromiso permanente direccionado al cumplimiento de nuestra razón de ser, visión y objetivo.
                          </p>

                      </div>

                  </div>

              </div>


              {/* // Seccion Footer */}
              <div className="footer-container-home">
                  <FooterComponent />

              </div>

    </div>
  </>

    );
}